/**
 * Shipping Progress Bar
 * ---------------------
 * Updates the free-shipping progress bar on every cart mutation. Reads the
 * threshold from the data attribute on the bar element, so it stays in sync
 * with the theme setting without needing a global config.
 *
 * Subtotal logic: uses cart.total_price MINUS any return-protection tier
 * variant line totals. (Protection shouldn't count toward free shipping.)
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      // Try a "no trailing zeros" format if the theme has one, else fall back
      var fmt = (window.theme.moneyFormatWithCurrency || window.theme.moneyFormat || '${{amount}}');
      return window.theme.Currency.formatMoney(cents, fmt);
    }
    // Plain fallback — strips trailing .00
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function isProtectionVariant(variantId) {
    if (!window.ReturnProtection || !window.ReturnProtection.getTiers) return false;
    var tiers = window.ReturnProtection.getTiers();
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].id === variantId) return true;
    }
    return false;
  }

  function calculateShippingSubtotal(cart) {
    var subtotal = cart.total_price || 0;
    (cart.items || []).forEach(function (item) {
      if (isProtectionVariant(item.variant_id)) {
        subtotal -= item.final_line_price;
      }
    });
    return Math.max(0, subtotal);
  }

  function updateBars(cart) {
    var bars = document.querySelectorAll('[data-shipping-progress]');
    if (!bars.length) return;

    var subtotal = calculateShippingSubtotal(cart);
    var itemCount = cart.item_count || 0;
    // Subtract protection lines from item count too — they shouldn't make an
    // empty cart appear non-empty.
    (cart.items || []).forEach(function (item) {
      if (isProtectionVariant(item.variant_id)) itemCount -= item.quantity;
    });

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10);
      if (isNaN(threshold) || threshold <= 0) return;

      // Hide bar entirely if cart has no eligible (non-protection) items
      if (itemCount <= 0) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;

      var fill = bar.querySelector('[data-sp-fill]');
      var textEl = bar.querySelector('[data-sp-text]');
      var messageEl = bar.querySelector('[data-sp-message]');
      var track = bar.querySelector('.shipping-progress__track');

      if (subtotal >= threshold) {
        // Unlocked
        if (fill) {
          fill.style.width = '100%';
          fill.classList.add('is-unlocked');
        }
        if (textEl) textEl.textContent = "You've unlocked Fast, Free Shipping";
        if (messageEl && !messageEl.querySelector('.shipping-progress__check')) {
          // Inject checkmark if not already there
          var check = document.createElement('span');
          check.className = 'shipping-progress__check';
          check.setAttribute('aria-hidden', 'true');
          check.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12 10 17 19 7"/></svg>';
          messageEl.insertBefore(check, messageEl.firstChild);
        }
        if (track) track.setAttribute('aria-valuenow', '100');
      } else {
        // Below threshold
        var pct = Math.round((subtotal / threshold) * 100);
        if (fill) {
          fill.style.width = pct + '%';
          fill.classList.remove('is-unlocked');
        }
        var remaining = threshold - subtotal;
        if (textEl) textEl.textContent = formatMoney(remaining) + ' away from Fast, Free Shipping';
        // Remove checkmark if present
        if (messageEl) {
          var existingCheck = messageEl.querySelector('.shipping-progress__check');
          if (existingCheck) existingCheck.remove();
        }
        if (track) track.setAttribute('aria-valuenow', String(pct));
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateBars)
      .catch(function () { /* silent */ });
  }

  function init() {
    // Listen for the same events the return protection controller listens to,
    // plus the protection sync event (so we update AFTER protection settles).
    [
      'ajaxProduct:added',
      'ajaxCart.afterCartLoad',
      'cart:updated',
      'cart:build',
      'return-protection:refreshed'
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        // Small delay to let the cart settle
        setTimeout(refresh, 100);
      });
    });

    // Also catch direct fetch cart mutations (belt-and-suspenders)
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
      var promise = originalFetch.apply(this, arguments);
      if (isCartMutation) {
        promise.then(function () { setTimeout(refresh, 150); }, function () {});
      }
      return promise;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();